module.exports = __webpack_public_path__ + "img/city1.8223daad.png";